/* istanbul ignore file */

import { SVGProps } from 'react';

export function PptxFileIcon({
  width = '24',
  height = '24',
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="4 4.42578 16 16"
      fill="none"
    >
      <path
        d="M4 7.42578C4 5.76893 5.34315 4.42578 7 4.42578H17C18.6569 4.42578 20 5.76893 20 7.42578V17.4258C20 19.0826 18.6569 20.4258 17 20.4258H7C5.34315 20.4258 4 19.0826 4 17.4258V7.42578Z"
        fill="#F1854B"
      />
      <path
        d="M11.9937 8.5293C13.0737 8.5293 13.8857 8.7693 14.4297 9.2493C14.9777 9.7253 15.2517 10.4213 15.2517 11.3373C15.2517 12.2493 14.9777 12.9453 14.4297 13.4253C13.8857 13.9053 13.0737 14.1453 11.9937 14.1453H10.7277V16.1073C10.7277 16.6393 10.4957 16.9053 10.0317 16.9053C9.79169 16.9053 9.61569 16.8373 9.50369 16.7013C9.39169 16.5653 9.33569 16.3673 9.33569 16.1073V9.3213C9.33569 8.7933 9.56769 8.5293 10.0317 8.5293H11.9937ZM11.9157 12.8733C12.5677 12.8733 13.0457 12.7453 13.3497 12.4893C13.6577 12.2293 13.8117 11.8453 13.8117 11.3373C13.8117 10.8293 13.6577 10.4473 13.3497 10.1913C13.0457 9.9313 12.5677 9.8013 11.9157 9.8013H10.7277V12.8733H11.9157Z"
        fill="white"
      />
    </svg>
  );
}
